import type { AppState } from 'state/state.model';

import type { BookingType, QuoteType } from './infos.model';

export function getWorkspaceFromQuoteId(state: AppState, quoteId: string) {
  return state.quotes.infos[quoteId]?.workspace;
}

export function getQuoteType(state: AppState, quoteId: string | undefined): QuoteType | undefined {
  if (quoteId === undefined) {
    return undefined;
  }
  return state.quotes.infos[quoteId]?.quoteType;
}

export function getBookingType(state: AppState, quoteId: string | undefined): BookingType | undefined {
  if (quoteId === undefined) {
    return undefined;
  }
  return state.quotes.infos[quoteId]?.bookingType;
}

export function isLoadingPreviousQuote(state: AppState, quoteId: string | undefined): boolean {
  if (quoteId === undefined) {
    return false;
  }
  return state.quotes.infos[quoteId]?.isLoadingPrevious ?? false;
}
